import React from 'react';
import useDreamSummary from '../hooks/useDreamSummary';
import { canShowBoosts, getEntryMultiplierValue } from '../utils/dreamBoost';
import '../styles/DreamBoost.css';

// The "5X entries" badge a merchant or offer carries while its own entry boost
// runs (embed renderEntryMultiplierBadgeHtml). Only with the school's Dream
// program on and a period running; the API attaches `entry_multiplier` to the
// merchant rows it applies to.
// `variant="overlay"` pins it to the top-right corner of a tile; `block` sits
// it in flow beside a name.
function EntryMultiplierBadge({ item, variant = 'overlay', compact = false }) {
  const summary = useDreamSummary();
  if (!canShowBoosts(summary)) return null;
  const multiplier = getEntryMultiplierValue(item);
  if (!multiplier) return null;
  const label = `${multiplier}X entries`;
  const classes = ['entry-multiplier-badge', `is-${variant}`];
  if (compact) classes.push('is-compact');
  return (
    <span className={classes.join(' ')} aria-label={label}>
      {label}
    </span>
  );
}

export default EntryMultiplierBadge;
